<template>
  <b-card class="card-home" no-body>
    <div class="content-img">
      <img :src="record.icon" :alt="record.title" />
      <span class=""
        >ACCESOS RÁPIDOS
        <p>{{ record.title }}</p>
      </span>
    </div>
    <hr />
    <div class="content-link-card">
      <span class="list-item-card" v-for="(item, index) in record.items" :key="index">
        <img
          src="@assets/images/file-icons/flecha-hacia-abajo.svg"
          :alt="item.title"
          class="icon-list"
        />
        <router-link :to="{ name: item.nameRoute }" class="link-card">
          {{ item.title }}
        </router-link>
      </span>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss">
.card-home {
  height: 240px;
  width: 267px;
  margin-bottom: 0 !important;
}
.content-img {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 18.65px;
}
.content-img img {
  width: 33px;
  height: 33px;
}
.content-img span {
  font-size: 12px;
  font-weight: 400;
}

.content-img span p {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0 !important;
}
.content-link-card {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16.5px;
  padding-top: 10px;
  padding-left: 40px;
}
.list-item-card {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.icon-list {
  width: 6px;
  height: 6px;
  margin-right: 9.9px;
}
.link-card {
  font-family: 'Work Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: black !important;
}
</style>
